import { PaymentRoutingModule } from './payment-routing.module';
import { AngularMaterialModule } from '@cradua/material';
import { GatewayModule } from '@cradua/gateway';
import { EpimsReferencesModule } from '@cradua/epims-references';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentComponent } from './components/payment/payment.component';
import { PaymentContainerComponent } from './containers/payment-container/payment-container.component';
import { BulkandsurfacerightComponent } from './components/bulkandsurfaceright/bulkandsurfaceright.component';
import { EnumeratedandagreageComponent } from './components/enumeratedandagreage/enumeratedandagreage.component';
import { PaymentProcessingComponent } from './components/payment-processing/payment-processing.component';
import {DatePipe} from '@angular/common';
import { PaymentPopupComponent } from './components/payment-popup/payment-popup.component'
import { LessorModalComponent } from './components/bulkandsurfaceright/lessor-modal/lessor-modal.component';
import { SearchDamageListComponent } from './components/enumeratedandagreage/search-damage-list/search-damage-list.component';
import { PaymentApprovalComponent } from './components/payment-approval/payment-approval.component';


@NgModule({
  imports: [CommonModule, ReactiveFormsModule, FormsModule, EpimsReferencesModule, GatewayModule, AngularMaterialModule, PaymentRoutingModule],
  declarations: [
    PaymentComponent,
    PaymentContainerComponent,
    BulkandsurfacerightComponent,
    EnumeratedandagreageComponent,
    PaymentProcessingComponent,
    PaymentPopupComponent,
    LessorModalComponent,
    SearchDamageListComponent,
    PaymentApprovalComponent,
  ],
  providers: [DatePipe, PaymentPopupComponent],
  exports: [PaymentComponent, PaymentContainerComponent,  BulkandsurfacerightComponent, EnumeratedandagreageComponent, PaymentProcessingComponent, PaymentPopupComponent]
})
export class PaymentModule {}
